import cx from "classnames";
import { useState } from "react";

import { Menu as AntdMenu } from "antd";

import { EMPLOYEE_PERFORMANCE_PAGE } from "../schemas/employeePerformanceSchema";
import styles from "../styles/Employee.module.css";
import menuStyles from "../styles/EmployeeMenu.module.css";
import { useSelector } from "react-redux";

function EmployeePerformanceMenu({ className = "", onChange = () => { } }) {
  const [selectedKeys, setSelectedKeys] = useState([
    EMPLOYEE_PERFORMANCE_PAGE.LEARNING,
  ]);
  const { roles } = useSelector((state) => state.company);
  function getItem(rules, i18n_key, label, key, icon, children, type) {
    let list = [...roles]
    if (!list.includes(rules)) {
      return {}
    }
    return {
      rules,
      i18n_key,
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const EMPLOYEE_WORKIN_MENU = [
    getItem(
      "ACCESS_EMPLOYEE|PERFORMANCE|LEARNING",
      EMPLOYEE_PERFORMANCE_PAGE.LEARNING,
      "Learning",
      EMPLOYEE_PERFORMANCE_PAGE.LEARNING
    ),
    getItem(
      "ACCESS_EMPLOYEE|PERFORMANCE|TRAINING",
      EMPLOYEE_PERFORMANCE_PAGE.TRAINING,
      "Traning",
      EMPLOYEE_PERFORMANCE_PAGE.TRAINING
    ),
    getItem(
      "ACCESS_EMPLOYEE|PERFORMANCE|SKILL",
      EMPLOYEE_PERFORMANCE_PAGE.SKILL,
      "Skill",
      EMPLOYEE_PERFORMANCE_PAGE.SKILL
    ),
    getItem(
      "ACCESS_EMPLOYEE|PERFORMANCE|ASSESSMENT_RESULTS",
      EMPLOYEE_PERFORMANCE_PAGE.ASSESSMENT_RESULTS,
      "Assessment Results",
      EMPLOYEE_PERFORMANCE_PAGE.ASSESSMENT_RESULTS
    ),
  ];

  const onMenuClick = (e) => {
    const key = e.key;
    setSelectedKeys([key]);
    onChange(key);
  };

  return (
    <div className={cx("card-mini", styles.menuContainer, className)}>
      <AntdMenu
        className={menuStyles.menu}
        defaultSelectedKeys={[EMPLOYEE_PERFORMANCE_PAGE.LEARNING]}
        selectedKeys={selectedKeys}
        mode="inline"
        items={EMPLOYEE_WORKIN_MENU.map((entity) => {
          return {
            ...entity,
            label: entity.label,
          };
        })}
        onClick={onMenuClick}
      />
    </div>
  );
}

export default EmployeePerformanceMenu;
